/** 账户详情 */
import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/verifynodes.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import DetailCard from '../components/cardInfoFour'
import SlideBtn, { type IbtnListItem } from '@/components/SlideBtn/index'
import { useMemo, useRef, useState } from 'react'
import AgsList from '../components/agsList/index'
import AgdList from '../components/agdList/index'
import AgeList from '../components/ageList/index'
import ShareCardList from '../components/shareCardList/index'
import { useTranslation } from 'react-i18next'
import MePagination from '@/components/MePagination'
import MePaginationNew from '@/components/MePaginationNew'
import DetailTransitionList from '../components/detailTransitionList'
import DetailModuleAccountTransition from '../components/detailModuleAccountTransition'
import { useParams } from 'react-router-dom'
import Tab from '@/components/Tab'
import { TabsProps } from 'antd'
import CheckinRecords from '../components/CheckinRecords'
import ModuleTransitionCheckin from '../components/moduleTransitionCheckin'
const AccontDetail = () => {
  const { t } = useTranslation()
  const { address } = useParams()
  const [btnListOne, setBtnListOne] = useState<IbtnListItem[]>([
    {
      name: 'AGD',
      value: '1',
      active: true,
    },
    {
      name: 'AGE',
      value: '2',
      active: false,
    },
    {
      name: 'AGS',
      value: '0',
      active: false,
    },
  ])
  const [agsPageParams, setAgsPageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [agsTotal, setAgsTotal] = useState(0)
  const [agsLoading, setAgsLoading] = useState(false)
  const [agdPageParams, setAgdPageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [agdTotal, setAgdTotal] = useState(0)
  const [agdLoading, setAgdLoading] = useState(false)
  const [agePageParams, setAgePageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [ageTotal, setAgeTotal] = useState(0)
  const [ageLoading, setAgeLoading] = useState(false)
  const activeBtnOne = useMemo(() => {
    return btnListOne.find((item) => item.active)
  }, [btnListOne])

  const [btnListTwo, setBtnListTwo] = useState<IbtnListItem[]>([
    {
      // 交易记录
      name: t('explorer_211'),
      value: '0',
      active: true,
    },
    {
      // 模块账户交易
      name: t('explorer_212'),
      value: '1',
      active: false,
    },
  ])

  const [TransitionTabItems] = useState<TabsProps['items']>([
    {
      key: 'hub',
      label: 'GEA HUB',
    },
    {
      key: 'rollapp_checkin',
      label: 'Rollapp Check-in',
    },
  ])
  const [checkinRecordsTab, setCheckinRecordsTab] = useState<'hub' | 'rollapp_checkin'>('hub')
  const [moduleTransitionCheckinTab, setModuleTransitionCheckinTab] = useState<
    'hub' | 'rollapp_checkin'
  >('hub')

  const activeBtnTwo = useMemo(() => {
    return btnListTwo.find((item) => item.active)
  }, [btnListTwo])

  // 交易hub
  const [detailTransitionPageParams, setDetailTransitionPageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [detailTransitionTotal, setDetailTransitionTotal] = useState(0)
  const [detailTransitionLoading, setDetailTransitionLoading] = useState(false)
  // 交易rollup
  const [rollappCheckinPageParams, setRollappCheckinPageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [rollappCheckinTotal, setRollappCheckinTotal] = useState(0)
  const [rollappCheckinLoading, setRollappCheckinLoading] = useState(false)
  // 交易模块
  const [detailModulePageParams, setDetailModulePageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [detailModuleTotal, setDetailModuleTotal] = useState(0)
  const [detailModuleLoading, setDetailModuleLoading] = useState(false)

  const [sharePageParams, setSharePageParams] = useState({
    offset: 0,
    page: 1,
    limit: 10,
  })
  const [shareListTotal, setShareListTotal] = useState(0)
  const [shareListLoading, setShareListLoading] = useState(false)
  // ----------------------------交易记录
  // next key 链表
  const transactionKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // next offset key 链表
  const transactionOffsetKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // 下一组key
  const transactionNextKey = useRef('')
  const transactionOffsetKey = useRef('')
  const [transactionNextKeyData, setTransactionNextKeyData] = useState<string>('')
  // 当前组索引
  const transactionCurrentGroupIndex = useRef(0)
  const transactionGroupSize = useRef(0)

  /**是否可以上一组下一组 */
  const transactionPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!transactionNextKeyData,
      canPrev: transactionCurrentGroupIndex.current > 0,
    }
  }, [transactionNextKeyData, transactionCurrentGroupIndex.current])

  // --------------------模块账户交易

  // next key 链表
  const moduleTransactionKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // next offset key 链表
  const moduleTransactionOffsetKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  // 下一组key
  const moduleTransactionNextKey = useRef('')
  const moduleTransactionOffsetKey = useRef('')
  const [moduleTransactionNextKeyData, setModuleTransactionNextKeyData] = useState<string>('')
  // 当前组索引
  const moduleTransactionCurrentGroupIndex = useRef(0)

  /**是否可以上一组下一组 */
  const moduleTransactionPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!moduleTransactionNextKeyData,
      canPrev: moduleTransactionCurrentGroupIndex.current > 0,
    }
  }, [moduleTransactionNextKeyData, moduleTransactionCurrentGroupIndex.current])

  // --------------------分享
  const shareKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })

  const shareNextKey = useRef('')
  const [shareNextKeyData, setShareNextKeyData] = useState<string>('')
  const shareCurrentGroupIndex = useRef(0)
  const shareGroupSize = useRef(0)

  const sharePaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!shareNextKeyData,
      canPrev: shareCurrentGroupIndex.current > 0,
    }
  }, [shareNextKeyData, shareCurrentGroupIndex.current])

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* 账户详情 */}
        {/* icon={icon} */}
        <Title title={t('explorer_198')} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      {/* 详情 */}
      <BlockTitle title={t('explorer_152')}></BlockTitle>
      <DetailCard />
      {/* AGS/AGD/AGE */}
      <div className="tab_three">
        <BlockTitle title={t('explorer_263')}></BlockTitle>
        <div className="tab_page_wrap">
          <SlideBtn btnList={btnListOne} setBtnList={setBtnListOne}></SlideBtn>
          <div className="gea_pagination_box gea_pagination_wrap">
            {activeBtnOne?.value === '0' && agsTotal > 0 && (
              <MePagination
                currentPage={agsPageParams.page}
                pageSize={agsPageParams.limit}
                total={agsTotal}
                loading={agsLoading}
                setPageParams={setAgsPageParams}
              />
            )}
            {activeBtnOne?.value === '1' && agdTotal > 0 && (
              <MePagination
                currentPage={agdPageParams.page}
                pageSize={agdPageParams.limit}
                total={agdTotal}
                loading={agdLoading}
                setPageParams={setAgdPageParams}
              />
            )}
            {activeBtnOne?.value === '2' && ageTotal > 0 && (
              <MePagination
                currentPage={agePageParams.page}
                pageSize={agePageParams.limit}
                total={ageTotal}
                loading={ageLoading}
                setPageParams={setAgePageParams}
              />
            )}
          </div>
        </div>
        <div className={styles.btn_list_one_warp}>
          <AgsList
            address={address!}
            activeValue={activeBtnOne?.value}
            pageParams={agsPageParams}
            setAgsTotal={setAgsTotal}
            setAgsLoading={setAgsLoading}
          />
          <AgdList
            address={address!}
            activeValue={activeBtnOne?.value}
            pageParams={agdPageParams}
            setAgdTotal={setAgdTotal}
            setAgdLoading={setAgdLoading}
          />
          <AgeList
            address={address!}
            activeValue={activeBtnOne?.value}
            pageParams={agePageParams}
            setAgeTotal={setAgeTotal}
            setAgeLoading={setAgeLoading}
          />
        </div>
        <div className="footer_pagination_account">
          {activeBtnOne?.value === '0' && agsTotal > 0 && (
            <MePagination
              currentPage={agsPageParams.page}
              pageSize={agsPageParams.limit}
              total={agsTotal}
              loading={agsLoading}
              setPageParams={setAgsPageParams}
            />
          )}
          {activeBtnOne?.value === '1' && agdTotal > 0 && (
            <MePagination
              currentPage={agdPageParams.page}
              pageSize={agdPageParams.limit}
              total={agdTotal}
              loading={agdLoading}
              setPageParams={setAgdPageParams}
            />
          )}
          {activeBtnOne?.value === '2' && ageTotal > 0 && (
            <MePagination
              currentPage={agePageParams.page}
              pageSize={agePageParams.limit}
              total={ageTotal}
              loading={ageLoading}
              setPageParams={setAgePageParams}
            />
          )}
        </div>
      </div>
      {/* 交易记录/模块账户交易 */}
      <div className="transaction_record">
        <div className="tab_page_wrap">
          {/* <SlideBtn btnList={btnListTwo} setBtnList={setBtnListTwo}></SlideBtn> */}
          <BlockTitle title={t('explorer_211')}></BlockTitle>
          <div className="gea_pagination_box gea_pagination_wrap">
            {activeBtnTwo?.value === '0' && checkinRecordsTab === 'hub' && (
              <MePaginationNew
                currentPage={detailTransitionPageParams.page}
                pageSize={detailTransitionPageParams.limit}
                setPageParams={setDetailTransitionPageParams}
                total={detailTransitionTotal}
                loading={detailTransitionLoading}
                paginationPreAndNext={transactionPaginationPreAndNext}
                groupSize={transactionGroupSize.current}
                groupIndex={transactionCurrentGroupIndex.current}
                prevKeyFn={() => {
                  if (detailTransitionLoading) return
                  if (transactionCurrentGroupIndex.current === 0) return
                  if (transactionCurrentGroupIndex.current > 0) {
                    transactionCurrentGroupIndex.current--
                  }
                  setDetailTransitionPageParams({
                    offset: 0,
                    limit: detailTransitionPageParams.limit,
                    page: 1,
                  })
                }}
                nextKeyFn={() => {
                  if (detailTransitionLoading) return
                  if (!transactionNextKey.current) return
                  transactionCurrentGroupIndex.current++
                  transactionKeyArray.current[transactionCurrentGroupIndex.current] =
                    transactionNextKey.current
                  transactionOffsetKeyArray.current[transactionCurrentGroupIndex.current] =
                    transactionOffsetKey.current
                  setDetailTransitionPageParams({
                    offset: 0,
                    limit: detailTransitionPageParams.limit,
                    page: 1,
                  })
                }}
              />
            )}
            {activeBtnTwo?.value === '0' && checkinRecordsTab === 'rollapp_checkin' && (
              <MePagination
                currentPage={rollappCheckinPageParams.page}
                pageSize={rollappCheckinPageParams.limit}
                total={rollappCheckinTotal}
                loading={rollappCheckinLoading}
                setPageParams={setRollappCheckinPageParams}
              />
            )}
            {activeBtnTwo?.value === '1' && moduleTransitionCheckinTab === 'hub' && (
              <MePaginationNew
                currentPage={detailModulePageParams.page}
                pageSize={detailModulePageParams.limit}
                total={detailModuleTotal}
                loading={detailModuleLoading}
                setPageParams={setDetailModulePageParams}
                paginationPreAndNext={moduleTransactionPaginationPreAndNext}
                prevKeyFn={() => {
                  if (detailModuleLoading) return
                  if (moduleTransactionCurrentGroupIndex.current === 0) return
                  if (moduleTransactionCurrentGroupIndex.current > 0) {
                    moduleTransactionCurrentGroupIndex.current--
                  }
                  setDetailModulePageParams({
                    offset: 0,
                    limit: detailModulePageParams.limit,
                    page: 1,
                  })
                }}
                nextKeyFn={() => {
                  if (detailModuleLoading) return
                  if (!moduleTransactionNextKey.current) return
                  moduleTransactionCurrentGroupIndex.current++
                  moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
                    moduleTransactionNextKey.current
                  moduleTransactionOffsetKeyArray.current[
                    moduleTransactionCurrentGroupIndex.current
                  ] = moduleTransactionOffsetKey.current
                  setDetailModulePageParams({
                    offset: 0,
                    limit: detailModulePageParams.limit,
                    page: 1,
                  })
                }}
              />
            )}
          </div>
        </div>
        {/* <div className={styles.hubTransitionTab}>
          <Tab
            items={TransitionTabItems}
            activeKey={activeBtnTwo?.value === '0' ? checkinRecordsTab : moduleTransitionCheckinTab}
            onChange={(key) => {
              if (activeBtnTwo?.value === '0') {
                setCheckinRecordsTab(key as 'hub' | 'rollapp_checkin')
              } else {
                setModuleTransitionCheckinTab(key as 'hub' | 'rollapp_checkin')
              }
            }}
          />
        </div> */}
        <div className="transaction_record_list">
          <DetailTransitionList
            address={address!}
            activeValue={activeBtnTwo?.value}
            checkinRecordsTab={checkinRecordsTab}
            pageParams={detailTransitionPageParams}
            setTotal={setDetailTransitionTotal}
            setLoading={setDetailTransitionLoading}
            nextKey={transactionNextKey}
            groupSize={transactionGroupSize}
            setNextKeyData={setTransactionNextKeyData}
            keyArray={transactionKeyArray}
            offsetKey={transactionOffsetKey}
            currentGroupIndex={transactionCurrentGroupIndex}
            offsetKeyArray={transactionOffsetKeyArray}
          />
          <CheckinRecords
            address={address!}
            activeValue={activeBtnTwo?.value}
            checkinRecordsTab={checkinRecordsTab}
            pageParams={rollappCheckinPageParams}
            setTotal={setRollappCheckinTotal}
            setLoading={setRollappCheckinLoading}
          />
          <DetailModuleAccountTransition
            address={address!}
            activeValue={activeBtnTwo?.value}
            pageParams={detailModulePageParams}
            moduleTransitionCheckinTab={moduleTransitionCheckinTab}
            setTotal={setDetailModuleTotal}
            setLoading={setDetailModuleLoading}
            nextKey={moduleTransactionNextKey}
            setNextKeyData={setModuleTransactionNextKeyData}
            keyArray={moduleTransactionKeyArray}
            offsetKey={moduleTransactionOffsetKey}
            currentGroupIndex={moduleTransactionCurrentGroupIndex}
            offsetKeyArray={moduleTransactionOffsetKeyArray}
          />
          <ModuleTransitionCheckin
            activeValue={activeBtnTwo?.value}
            moduleTransitionCheckinTab={moduleTransitionCheckinTab}
          ></ModuleTransitionCheckin>
        </div>
        <div className="footer_pagination_account">
          {activeBtnTwo?.value === '0' && checkinRecordsTab === 'hub' && (
            <MePaginationNew
              currentPage={detailTransitionPageParams.page}
              pageSize={detailTransitionPageParams.limit}
              setPageParams={setDetailTransitionPageParams}
              total={detailTransitionTotal}
              loading={detailTransitionLoading}
              paginationPreAndNext={transactionPaginationPreAndNext}
              groupSize={transactionGroupSize.current}
              groupIndex={transactionCurrentGroupIndex.current}
              prevKeyFn={() => {
                if (detailTransitionLoading) return
                if (transactionCurrentGroupIndex.current === 0) return
                if (transactionCurrentGroupIndex.current > 0) {
                  transactionCurrentGroupIndex.current--
                }
                setDetailTransitionPageParams({
                  offset: 0,
                  limit: detailTransitionPageParams.limit,
                  page: 1,
                })
              }}
              nextKeyFn={() => {
                if (detailTransitionLoading) return
                if (!transactionNextKey.current) return
                transactionCurrentGroupIndex.current++
                transactionKeyArray.current[transactionCurrentGroupIndex.current] =
                  transactionNextKey.current
                transactionOffsetKeyArray.current[transactionCurrentGroupIndex.current] =
                  transactionOffsetKey.current
                setDetailTransitionPageParams({
                  offset: 0,
                  limit: detailTransitionPageParams.limit,
                  page: 1,
                })
              }}
            />
          )}
          {activeBtnTwo?.value === '0' && checkinRecordsTab === 'rollapp_checkin' && (
            <MePagination
              currentPage={rollappCheckinPageParams.page}
              pageSize={rollappCheckinPageParams.limit}
              total={rollappCheckinTotal}
              loading={rollappCheckinLoading}
              setPageParams={setRollappCheckinPageParams}
            />
          )}
          {activeBtnTwo?.value === '1' && moduleTransitionCheckinTab === 'hub' && (
            <MePaginationNew
              currentPage={detailModulePageParams.page}
              pageSize={detailModulePageParams.limit}
              total={detailModuleTotal}
              loading={detailModuleLoading}
              setPageParams={setDetailModulePageParams}
              paginationPreAndNext={moduleTransactionPaginationPreAndNext}
              prevKeyFn={() => {
                if (detailModuleLoading) return
                if (moduleTransactionCurrentGroupIndex.current === 0) return
                if (moduleTransactionCurrentGroupIndex.current > 0) {
                  moduleTransactionCurrentGroupIndex.current--
                }
                setDetailModulePageParams({
                  offset: 0,
                  limit: detailModulePageParams.limit,
                  page: 1,
                })
              }}
              nextKeyFn={() => {
                if (detailModuleLoading) return
                if (!moduleTransactionNextKey.current) return
                moduleTransactionCurrentGroupIndex.current++
                moduleTransactionKeyArray.current[moduleTransactionCurrentGroupIndex.current] =
                  moduleTransactionNextKey.current
                moduleTransactionOffsetKeyArray.current[
                  moduleTransactionCurrentGroupIndex.current
                ] = moduleTransactionOffsetKey.current
                setDetailModulePageParams({
                  offset: 0,
                  limit: detailModulePageParams.limit,
                  page: 1,
                })
              }}
            />
          )}
        </div>
      </div>
      {/* 分享 */}
      <div className="share_wrap">
        <div className="tab_page_wrap">
          <BlockTitle title={t('explorer_213')}></BlockTitle>
          <div className="gea_pagination_box gea_pagination_wrap">
            <MePaginationNew
              currentPage={sharePageParams.page}
              pageSize={sharePageParams.limit}
              total={shareListTotal}
              loading={shareListLoading}
              setPageParams={setSharePageParams}
              paginationPreAndNext={sharePaginationPreAndNext}
              groupSize={shareGroupSize.current}
              groupIndex={shareCurrentGroupIndex.current}
              prevKeyFn={() => {
                if (shareListLoading) return
                if (shareCurrentGroupIndex.current === 0) return
                if (shareCurrentGroupIndex.current > 0) {
                  shareCurrentGroupIndex.current--
                }
                setSharePageParams({
                  offset: 0,
                  limit: sharePageParams.limit,
                  page: 1,
                })
              }}
              nextKeyFn={() => {
                if (shareListLoading) return
                if (!shareNextKey.current) return
                shareCurrentGroupIndex.current++
                shareKeyArray.current[shareCurrentGroupIndex.current] = shareNextKey.current
                setSharePageParams({
                  offset: 0,
                  limit: sharePageParams.limit,
                  page: 1,
                })
              }}
            />
          </div>
        </div>
        <div className="share_wrap_content">
          <ShareCardList
            address={address!}
            pageParams={sharePageParams}
            setTotal={setShareListTotal}
            setLoading={setShareListLoading}
            nextKey={shareNextKey}
            setNextKeyData={setShareNextKeyData}
            keyArray={shareKeyArray}
            currentGroupIndex={shareCurrentGroupIndex}
            groupSize={shareGroupSize}
          />
          <div className="footer_pagination_account">
            <MePaginationNew
              currentPage={sharePageParams.page}
              pageSize={sharePageParams.limit}
              total={shareListTotal}
              loading={shareListLoading}
              setPageParams={setSharePageParams}
              paginationPreAndNext={sharePaginationPreAndNext}
              groupSize={shareGroupSize.current}
              groupIndex={shareCurrentGroupIndex.current}
              prevKeyFn={() => {
                if (shareListLoading) return
                if (shareCurrentGroupIndex.current === 0) return
                if (shareCurrentGroupIndex.current > 0) {
                  shareCurrentGroupIndex.current--
                }
                setSharePageParams({
                  offset: 0,
                  limit: sharePageParams.limit,
                  page: 1,
                })
              }}
              nextKeyFn={() => {
                if (shareListLoading) return
                if (!shareNextKey.current) return
                shareCurrentGroupIndex.current++
                shareKeyArray.current[shareCurrentGroupIndex.current] = shareNextKey.current
                setSharePageParams({
                  offset: 0,
                  limit: sharePageParams.limit,
                  page: 1,
                })
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccontDetail
